<template>
    <i class="fa" :class="iconClass"></i>
</template>

<script>
    import moment from 'moment'
    
    export default { 
        props: ['logLine'],
        
        computed: {
            iconClass() {
                if (this.logLine.event === 'company-created' || this.logLine.event === 'company-updated') {
                    return 'fa-building'
                }

                if (this.logLine.event === 'person-created' || this.logLine.event === 'person-updated') {
                    return 'fa-user'
                }

                if (this.logLine.event === 'invoice-created' || this.logLine.event === 'invoice-drafted' || this.logLine.event === 'invoice-paid') {
                    return 'fa-file-invoice-dollar'
                }

                if (this.logLine.event === 'subscription-created' || this.logLine.event === 'subscription-updated') {
                    return 'fa-book-reader'
                }

                if (this.logLine.event === 'order-created' || this.logLine.event === 'order-updated') {
                    return 'fa-bullhorn'
                }

                if (this.logLine.event === 'order-confirmation-created') {
                    return 'fa-file-invoice-dollar'
                }

                if (this.logLine.event === 'opportunity-created' || this.logLine.event === 'opportunity-updated' || this.logLine.event === 'opportunity-closed' || this.logLine.event === 'opportunity-converted-to-order' || this.logLine.event === 'opportunity-converted-to-subscription') {
                    return 'fa-comments-dollar'
                }

                if (this.logLine.event === 'email-created') {
                    return 'fa-envelope'
                }

                if (this.logLine.event === 'reminder-created') {
                    if(moment(this.logLine.subject.remind_at).isBefore(moment()) && ! this.logLine.subject.resolved_at) {
                        return 'fa-bell faa-ring animated'
                    }

                    return 'fa-bell'
                }

                if (this.logLine.event === 'comment-created') {
                    return 'fa-comment'
                }

                return 'fa-question'
            }
        }
    }
</script>

<style>
    /* BELL */

    @-webkit-keyframes ring {
        0% {
            -webkit-transform: rotate(-15deg);
            transform: rotate(-15deg);
        }

        2% {
            -webkit-transform: rotate(15deg);
            transform: rotate(15deg);
        }

        4% {
            -webkit-transform: rotate(-18deg);
            transform: rotate(-18deg);
        }

        6% {
            -webkit-transform: rotate(18deg);
            transform: rotate(18deg);
        }

        8% {
            -webkit-transform: rotate(-22deg);
            transform: rotate(-22deg);
        }

        10% {
            -webkit-transform: rotate(22deg);
            transform: rotate(22deg);
        }

        12% {
            -webkit-transform: rotate(-18deg);
            transform: rotate(-18deg);
        }

        14% {
            -webkit-transform: rotate(18deg);
            transform: rotate(18deg);
        }

        16% {
            -webkit-transform: rotate(-12deg);
            transform: rotate(-12deg);
        }

        18% {
            -webkit-transform: rotate(12deg);
            transform: rotate(12deg);
        }

        20% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
    }

    @keyframes ring {
        0% {
            -webkit-transform: rotate(-15deg);
            -ms-transform: rotate(-15deg);
            transform: rotate(-15deg);
        }

        2% {
            -webkit-transform: rotate(15deg);
            -ms-transform: rotate(15deg);
            transform: rotate(15deg);
        }

        4% {
            -webkit-transform: rotate(-18deg);
            -ms-transform: rotate(-18deg);
            transform: rotate(-18deg);
        }

        6% {
            -webkit-transform: rotate(18deg);
            -ms-transform: rotate(18deg);
            transform: rotate(18deg);
        }

        8% {
            -webkit-transform: rotate(-22deg);
            -ms-transform: rotate(-22deg);
            transform: rotate(-22deg);
        }

        10% {
            -webkit-transform: rotate(22deg);
            -ms-transform: rotate(22deg);
            transform: rotate(22deg);
        }

        12% {
            -webkit-transform: rotate(-18deg);
            -ms-transform: rotate(-18deg);
            transform: rotate(-18deg);
        }

        14% {
            -webkit-transform: rotate(18deg);
            -ms-transform: rotate(18deg);
            transform: rotate(18deg);
        }

        16% {
            -webkit-transform: rotate(-12deg);
            -ms-transform: rotate(-12deg);
            transform: rotate(-12deg);
        }

        18% {
            -webkit-transform: rotate(12deg);
            -ms-transform: rotate(12deg);
            transform: rotate(12deg);
        }

        20% {
            -webkit-transform: rotate(0deg);
            -ms-transform: rotate(0deg);
            transform: rotate(0deg);
        }
    }

    .faa-ring.animated,
    .faa-ring.animated-hover:hover,
    .faa-parent.animated-hover:hover > .faa-ring {
        -webkit-animation: ring 2s ease infinite;
        animation: ring 2s ease infinite;
        transform-origin-x: 50%;
        transform-origin-y: 0px;
        transform-origin-z: initial;
    }

</style>
